import { useNavigate, useLocation } from "react-router-dom";
import { LayoutDashboard, Users, Receipt, FileText, Settings, ScrollText, ArrowLeft, Bus } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { LEGACY_LOGO_URL as LOGO_URL } from "@/lib/api";

const NAV = [
  { to: "/easytrasporto", label: "Dashboard", icon: LayoutDashboard, exact: true },
  { to: "/easytrasporto/beneficiari", label: "Beneficiari", icon: Users },
  { to: "/easytrasporto/quote", label: "Quote & Incassi", icon: Receipt },
  { to: "/easytrasporto/ricevute", label: "Ricevute", icon: FileText },
  { to: "/easytrasporto/config", label: "Configurazione", icon: Settings, adminOnly: true },
  { to: "/easytrasporto/log", label: "Log", icon: ScrollText, adminOnly: true },
];

export const euro = (v) =>
  `€ ${Number(v || 0).toLocaleString("it-IT", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;

export const ETLayout = ({ children, title, subtitle, actions }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const { user } = useAuth();
  const isActive = (i) => (i.exact ? location.pathname === i.to : location.pathname.startsWith(i.to));

  return (
    <div className="min-h-screen bg-slate-50">
      <header className="sticky top-0 z-40 bg-white border-b border-slate-200">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 h-16 flex items-center justify-between">
          <div className="flex items-center gap-3">
            <button data-testid="et-back-area" onClick={() => navigate("/area-riservata")} className="flex items-center gap-1.5 text-sm text-slate-500 hover:text-slate-900 px-2 py-1.5 rounded-md hover:bg-slate-100 transition-all">
              <ArrowLeft className="h-4 w-4" /> Area
            </button>
            <div className="h-5 w-px bg-slate-200" />
            <img src={LOGO_URL} alt="Assietica" className="h-11 w-auto object-contain" />
            <div className="hidden sm:flex items-center gap-2 leading-tight">
              <Bus className="h-4 w-4 text-brand-green" />
              <div>
                <div className="font-heading font-semibold text-slate-900">Gestione Servizi Trasporto</div>
                <div className="flex items-center gap-2">
                  <span className="text-[10px] uppercase tracking-widest text-slate-400">ANFFAS APS · Area Riservata</span>
                  <span className="inline-flex items-center gap-1 text-[9px] font-semibold uppercase tracking-wide px-1.5 py-0.5 rounded-full bg-violet-100 text-violet-700" data-testid="et-benefit-badge">
                    Benefit ETS
                  </span>
                </div>
              </div>
            </div>
          </div>
          <span className="text-xs text-slate-500 hidden md:block">{user?.email}</span>
        </div>
        <nav className="max-w-7xl mx-auto px-4 sm:px-6 flex gap-1 overflow-x-auto">
          {NAV.filter((n) => !n.adminOnly || user?.role === "admin").map((n) => {
            const Icon = n.icon; const active = isActive(n);
            return (
              <button key={n.to} data-testid={`et-nav-${n.label.toLowerCase().replace(/[^a-z]/g, "-")}`} onClick={() => navigate(n.to)}
                className={`flex items-center gap-2 px-3 py-2.5 text-sm border-b-2 transition-all whitespace-nowrap ${active ? "border-brand-green text-emerald-600 font-medium" : "border-transparent text-slate-500 hover:text-slate-900"}`}>
                <Icon className="h-4 w-4" /> {n.label}
              </button>
            );
          })}
        </nav>
      </header>
      <main className="max-w-7xl mx-auto px-4 sm:px-6 py-8">
        {(title || actions) && (
          <div className="flex items-start justify-between mb-6 gap-4 flex-wrap">
            <div>
              {subtitle && <p className="text-xs uppercase tracking-[0.2em] text-slate-400 mb-1">{subtitle}</p>}
              {title && <h1 className="font-heading text-2xl sm:text-3xl font-medium text-slate-900 tracking-tight">{title}</h1>}
            </div>
            {actions}
          </div>
        )}
        {children}
      </main>
    </div>
  );
};

export const QUOTA_STATE = {
  DA_PAGARE: { label: "Da pagare", cls: "bg-red-100 text-red-700" },
  PARZIALE: { label: "Parziale", cls: "bg-amber-100 text-amber-700" },
  PAGATO: { label: "Pagato", cls: "bg-emerald-100 text-emerald-700" },
  PRIMO_SOLLECITO: { label: "1° sollecito", cls: "bg-orange-100 text-orange-700" },
  SECONDO_SOLLECITO: { label: "2° sollecito", cls: "bg-orange-200 text-orange-800" },
  ULTIMO_SOLLECITO: { label: "Ultimo sollecito", cls: "bg-red-200 text-red-800" },
  SERVIZIO_SOSPESO: { label: "Servizio sospeso", cls: "bg-slate-200 text-slate-700" },
};

export const QuotaBadge = ({ stato }) => {
  const m = QUOTA_STATE[stato] || QUOTA_STATE.DA_PAGARE;
  return <span className={`text-xs px-2 py-0.5 rounded-full font-medium ${m.cls}`}>{m.label}</span>;
};
